export const FILTER_COLUMN_AUTOCOMPLETE_CLASS = 'filter-column-autocomplete';
export const FILTER_COLUMN_LISTBOX_MAX_HEIGHT = 280;
export const FILTER_DATE_RANGE_CLASS = 'date-range-filter';
